/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outbox': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M115.6 51.5v97.9h22.8V51.5l26.1 26.2 16.2-16.2L127 7.9 73.3 61.5l16.2 16.2zM167.9 160.8l-22.8 22.8h-36.2l-22.8-22.8H13V252h228v-91.2h-73.1zm50.3 68.4H35.8v-45.6h40.9l22.8 22.8h55l22.8-22.8h40.9v45.6z"/>'
  }
})
